<template>
  <v-container class="fill-height">
    <v-row justify="center" align="center">
      <v-col cols="12" sm="1">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'LoadingIndicator',
};
</script>
